import CourseElement, {
  CourseElementType,
} from '@/components/elements/CourseElement';
import Spacer from '@/components/elements/Spacer';
import { Flex, Heading } from '@chakra-ui/react';
import random from 'lodash/random';
import { useTranslation } from 'next-i18next';
import React, { memo } from 'react';
import Marquee from 'react-fast-marquee';
import lectures from './lectures.json';

const ResourcesCarousel = () => {
  const processed = (() => {
    const temp: CourseElementType[] = [];
    lectures.lectures.forEach((item) => {
      let index = 0;
      item.topics.forEach((el) => {
        temp.push({
          title: el,
          topic: item.name as any,
          type: [`lesson`, `test`, `video`][index] as any,
        });
        index += 1;
        if (index > 2) {
          index = 0;
        }
      });
    });
    return temp;
  })();
  const { t } = useTranslation(`common`);
  return (
    <Flex as="section" direction="column">
      <Heading px="10" mb={[12, null, 28]} size="2xl" textAlign="center">
        {t(`resources.header`)}
      </Heading>

      <Marquee
        style={{ overflowY: `hidden` }}
        direction="left"
        speed={10}
        gradient={false}
      >
        {processed.map((item) => (
          <CourseElement
            key={`${item.title}-${item.topic}`}
            title={item.title}
            topic={item.topic}
            type={item.type}
          />
        ))}
      </Marquee>
      <Spacer height={[11, null, 19]} />
      <Marquee
        style={{ overflowY: `hidden` }}
        direction="right"
        speed={10}
        gradient={false}
      >
        {processed.map((item) => (
          <CourseElement
            key={`${item.title}-${item.topic}`}
            title={item.title}
            topic={item.topic}
            type={item.type}
          />
        ))}
      </Marquee>
    </Flex>
  );
};

export default memo(ResourcesCarousel);
